import React, { useEffect } from 'react';
import { useMutation } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { Form, Input, TreeSelect } from 'antd';
import Drawer from 'components/Drawer';

const EDIT_MUTATION = gql`
  mutation EditFile($id: ID!, $input: EditFileInput!) {
    editFile(id: $id, input: $input) {
      id
    }
  }
`;

const EditFile = ({ file, onCancel, folders }) => {
  const [editFileMutation] = useMutation(EDIT_MUTATION, { refetchQueries: ['Files'] });
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [file]);

  const onFinish = async (values) => {
    const input = {
      title: values.title,
      folder: values.folder === 'new' ? values.newFolder : values.folder,
    };
    await editFileMutation({ variables: { id: file.id, input } });
    onCancel();
  };

  const initialValues = {
    title: file?.title,
    folder: file?.folder,
  };

  const treeData = [...folders, { title: <i>Create new folder</i>, value: 'new', nodeTitle: <i>Create new folder</i> }];

  return (
    <Drawer open={file} onOk={() => form.submit()} onCancel={onCancel} title="Edit file">
      <Form form={form} initialValues={initialValues} layout="vertical" onFinish={onFinish}>
        <Form.Item name="title" label="Filename">
          <Input />
        </Form.Item>
        <Form.Item name="folder" label="Folder">
          <TreeSelect treeData={treeData} treeDefaultExpandAll treeLine={{ showLeafIcon: false }} treeNodeLabelProp="nodeTitle" />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues.folder !== curValues.folder}>
          {({ getFieldValue }) => (getFieldValue('folder') === 'new' && (
            <Form.Item name="newFolder" label="New folder name" help="use / to create multiple levels">
              <Input />
            </Form.Item>
          ))}
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default EditFile;
